export const DISCORD_INVITE_URL = 'https://discord.gg/nfwPRb9';
export const GITHUB_REPO_URL = 'https://github.com/samuelmaddock/metastream';
